import React from 'react';
import './Footer.css';
import logo from '../logo.png';

const Footer = () => {
    return (
        <footer className="main-footer">
            <div className="footer-content">
                <div className="footer-company-info">
                    <img src={logo} alt="D-Astars Logo" className="footer-logo" />
                    <p>D-Astars International Trade - A trusted and registered Indian pharmaceutical company dedicated to manufacturing and marketing top-quality pharmaceutical formulations.</p>
                </div>
                
                <div className="footer-contact">
    <h3>Contact Information</h3>
                <div className="contact-details">
                    <a href="https://goo.gl/maps" target="_blank" rel="noopener noreferrer">
                        <p><i className="fa-solid fa-location-dot"></i> Address: PROP NO NEW 1742,OLD 4_NEW, PLOT NO 11B, SURVAY NO 167/1, WD NO A7, KURHEAPPA LAYOUT,TREASURY COLONY, , NR SSD BAGLO Tal : AMRAVATI ( AMARAVATI ) Pin : 444601</p>
                    </a>
                    
                    <p><i className="fa-solid fa-envelope"></i> Email:</p>
                    <ul>
                        <li><a href="mailto:dastarstrade13@gmail.com">dastarstrade13@gmail.com</a></li>
                        <li><a href="mailto:dastarstrade75@gmail.com">dastarstrade75@gmail.com</a></li>
                        <li><a href="mailto:dastarstrade77@gmail.com">dastarstrade77@gmail.com</a></li>
                        <li><a href="mailto:dastarstrade76@gmail.com">dastarstrade76@gmail.com</a></li>
                    </ul>

                    <p><i className="fa-solid fa-phone"></i> Contact:</p>
                    <ul>
                        <li><a href="tel:+918237434068">+91 82374 34068</a></li>
                        <li><a href="tel:+918482995385">+91 84829 95385</a></li>
                        <li><a href="tel:+9182837434068">+91 82837 434068</a></li>
                        <li><a href="tel:+918855076552">+91 88550 76552</a></li>
                        <li><a href="tel:+918855076558">+91 88550 76558</a></li>
                    </ul>
                </div>
            </div>


                <div className="footer-social">
                    <h3>Connect With Us</h3>
                    <div className="social-links">
                        <a href="https://www.facebook.com/people/D-A-stars-International-Trade/61568409791499/" target="_blank" rel="noopener noreferrer" className="social-icon">
                            <i className="fa-brands fa-facebook-f"></i>
                        </a>
                        <a href="https://www.linkedin.com/in/deva-pundkar-2a5866334" target="_blank" rel="noopener noreferrer" className="social-icon">
                            <i className="fa-brands fa-linkedin-in"></i>
                        </a>
                        <a href="https://www.instagram.com/dastars13" target="_blank" rel="noopener noreferrer" className="social-icon">
                            <i className="fa-brands fa-instagram"></i>
                        </a>
                        <a href="http://www.youtube.com/@D-Astarsinternationaltrade-h4i" target="_blank" rel="noopener noreferrer" className="social-icon">
                            <i className="fa-brands fa-youtube"></i>
                        </a>
                        <a href="mailto:dastarstrade13@gmail.com" className="social-icon">
                            <i className="fa-solid fa-envelope"></i>
                        </a>
                        <a href="https://wa.me/8237434068" className="social-icon whatsapp">
                            <i className="fab fa-whatsapp"></i>
                        </a>
                    </div>
                </div>

                <div className="footer-map">
                    <h3>Find Us</h3>
                    <div className="map-container">
                    <iframe
                        title="D-Astars Healthcare Location Map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3733.5760050164685!2d77.7620292!3d20.9641874!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd7c157eefdc595%3A0x77c1df5c20f13c3c!2sD-Astars%20Healthcare!5e0!3m2!1sen!2sin!4v1715521545674!5m2!1sen!2sin"
                        width="300"
                        height="250"
                        style={{ border: 0, borderRadius: "12px" }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                    </div>
                </div>
            </div>
            
            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} D-Astars International Trade. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
